// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__oABKf","itemTitle":"ClientEmergencyInfo_itemTitle__3muPc","itemText":"ClientEmergencyInfo_itemText__38lVe"};